export default __webpack_public_path__ + "static/media/Submarine_LE.9286bb4d.jpg";